import React from 'react';
import { ShieldCheckIcon } from 'lucide-react';
import { Reveal } from './Reveal';
export function GuaranteeSection() {
  return <section aria-label="Garantía" className="w-full bg-sage-100 py-16 sm:py-20" data-id="element-82" data-mp="4vs1604r2hrx">
      <div className="mx-auto max-w-2xl px-5 text-center sm:px-8" data-id="element-83" data-mp="9tbcosa2cgg6">
        <Reveal data-id="element-84" data-mp="et66b3l83k4x">
          <span className="mx-auto flex h-16 w-16 items-center justify-center rounded-full bg-sage-500 shadow-warm" data-id="element-85" data-mp="etpngi31u4hw">
            <ShieldCheckIcon aria-hidden="true" className="h-8 w-8 text-cream-50" data-id="element-86" data-mp="jrr651wkc1su" />
          </span>
          <h2 className="mt-6 font-display text-2xl font-semibold tracking-tight text-bark-900 sm:text-3xl" data-id="element-87" data-mp="nst7boa1inxg">
            🛡️ GARANTÍA 7 DÍAS — SIN PREGUNTAS
          </h2>
          <p className="mt-5 text-base leading-relaxed text-bark-600 sm:text-lg" data-id="element-88" data-mp="xkgrd449p2ow">
            Abrís los tomos. Los usás con tus hijos esta semana.
          </p>
          <p className="mt-3 text-base leading-relaxed text-bark-800 sm:text-lg" data-id="element-89" data-mp="12gxje9el8179">
            Si en 7 días no es lo que esperabas:{' '}
            <span className="font-semibold" data-id="element-90" data-mp="25sghnddhe60c">devolución del 100%</span>, sin formularios, sin drama.
          </p>
        </Reveal>
      </div>
    </section>;
}